import { AdminUserPermissionsEnum } from '@/lib/enum';
import { Button } from '@/components/ui/button.tsx';
import { IHasClassName } from '@/interfaces';
import { SecuredComponent } from '../hoc';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';
import routes from '@/lib/routes';
import { cn } from '@/lib/utils';

type TProps = IHasClassName & {
	align?: 'left' | 'right' | 'center';
	deviceAccountsCount: number;
	userId: string;
}

const NbrOfAccountsText = ({ deviceAccountsCount, userId, className, align }: TProps) => {

	if (!(deviceAccountsCount > 1)) {
		return <></>;
	}

	return (
		<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.USERS_SUB_ACCOUNTS]}>
			<div className={cn(
				'flex items-center text-muted-foreground space-x-1 text-sm self-stretch',
				align === 'center' && 'justify-center',
				align === 'right' && 'justify-end',
				className
			)}>
				<Users size={16} />
				<span>
					Nombre de comptes actifs: {deviceAccountsCount}
				</span>
				{
					deviceAccountsCount >= 2 &&
					<Link to={`${routes.nav.users.single.getHref(userId)}?tab=subAccounts`}>
						<Button
							size='sm'
							type='button'
							variant='link'
							className='text-purple-600 h-0'>
							Voir
						</Button>
					</Link>
				}
			</div>
		</SecuredComponent>
	);

};

export default NbrOfAccountsText;
